export default __webpack_public_path__ + "a2cb44fb69535e6e3977aa66929628c8.png";